import { Component, ElementRef, HostListener, OnInit, effect, inject, ViewChild } from '@angular/core';
import { PartnerService } from '../service/partner.service';
import { SharedSignalsService } from 'src/app/common/services/shared-signals.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'taly-shops',
  templateUrl: './shops.component.html',
  styleUrls: ['./shops.component.scss']
})
export class ShopsComponent implements OnInit {

  shopList: any[] = [];
  textDirection: string;
  transferSignal = inject(SharedSignalsService);
  currentPage: number = 0;
  pageSize: number = 8;
  totalPages: number;
  totalRecords: number;
  isLoadingStarted: boolean = false;

  @ViewChild('shopElement', { static: false }) public shopElement: ElementRef;

  constructor(private partnerService: PartnerService, private elementRef: ElementRef,
    private breakpointObserver: BreakpointObserver
  ) {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  ngOnInit(): void {

    this.breakpointObserver.observe([
      Breakpoints.Handset,        // Mobile
      Breakpoints.Tablet,         // Tablet
      Breakpoints.Web,            // Web/Desktop
    ]).subscribe((result) => {
      console.log('Breakpoint Observer Result:', result);
      console.log(Breakpoints.Web)
      console.log('Breakpoints:', result.breakpoints);
      if (result.matches) {
        // Check specific breakpoints
        if (result.breakpoints[Breakpoints.Handset]) {
          console.log('Handset matched');
          this.pageSize = 4; // Mobile
        } else if (result.breakpoints[Breakpoints.Tablet]) {
          console.log('Tablet matched');
          this.pageSize = 6; // Tablet
        } else if (result.breakpoints[Breakpoints.Web]) {
          console.log('Web/Desktop matched');
          this.pageSize = 8; // Web/Desktop
        } else {
          this.pageSize = 8; 
          console.log('No specific breakpoint matched, using default');
        }
      } else {
        console.log('No breakpoints matched');
      }
    });

    setTimeout(() => {

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 401);
    this.getShops();
  }

  getShops() {
    let param = `page=${this.currentPage}&size=${this.pageSize}`;
    this.partnerService.getShopsList(param).subscribe(
      resp => {
        if (this.shopList.length > 0) {
          this.shopList = [...this.shopList, ...resp?.records];
        } else {
          this.shopList = resp?.records;
        }
        this.currentPage = resp?.currentPage;
        this.totalPages = resp?.totalPages;
        this.totalRecords = resp?.totalRecords;
        this.isLoadingStarted = false;
      },
      err => {
        this.transferSignal.showMessage('error', err?.message || err);
        this.isLoadingStarted = false;
      }
    );
  }

  //@HostListener('window:scroll', ['$event'])
  onScrollLoadData() {
    const nativeElement = this.shopElement.nativeElement;
    const windowHeight = window.innerHeight;
    const scrollY = window.scrollY || window.pageYOffset;

    const elementRect = nativeElement.getBoundingClientRect();
    const elementTop = elementRect.top + window.scrollY;
    const elementHeight = elementRect.height;
    const distanceToBottom = elementHeight - 20 - scrollY;
    if (distanceToBottom < 1 && this.currentPage < this.totalPages && !this.isLoadingStarted) {
      this.currentPage++;
      this.isLoadingStarted = true;
      this.getShops();
    }
  }

  loadMoreShope(){
    if(this.currentPage < this.totalPages){
      this.currentPage++;
      this.isLoadingStarted = true;
      this.getShops();
    }
  }
}
